<template>
  <ContentBase>
    <ServiceRow
      :part="part"
      :partIndex="partIndexes[0]"
    />
  </ContentBase>
</template>

<script
  lang="ts"
  setup
>
import type { AppointmentPartAttributes } from '@/types';
import ContentBase from './ContentBase.vue';
import ServiceRow from './ServiceRow.vue';

defineProps<{
  part: AppointmentPartAttributes;
  partIndexes: number[];
}>();
</script>
